import { render } from "./textMessage.vue?vue&type=template&id=69935b59&scoped=true"
import script from "./textMessage.vue?vue&type=script&lang=js"
export * from "./textMessage.vue?vue&type=script&lang=js"

import "./textMessage.vue?vue&type=style&index=0&id=69935b59&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69935b59"]])

export default __exports__